import React, { Component } from "react";
import Image from "../../../../../../components/ZUILib/Image";
import commonUtil from "../../../../../../utils/commonUtil";
import * as defaultConst from "../../../../../../utils/clientConstant";

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];
class Template extends Component {
  render() {
    const { giftDetail , eventContractInfo } = this.props;
    const giftSection = "ComprasPersonales";
    const labels = this.props.lables;
    const _imgsrc = [
      {
        media: "(max-width: 465px)",
        srcSet: giftDetail.imageURL, // TODO: Need to upload all images in static asset
      },
    ];
    const imageAttr = {
      id: "img1",
      alt: "Liverpool",
      src: giftDetail.imageURL, // TODO: Need to upload all images in static asset
      altImg: giftDetail?.altImageUrl || commonUtil.getAssetURL() + "/images/guest/no-image.png",
      // className: "img-responsive center-block giftImgHeight",
      className: "receivedGiftImg",
      pictureHtmlStyle: {
        maxHeightPicture: '106px',
        maxWidthPicture: '88px',
      },
    };

    if (commonUtil.isEmpty(giftDetail) || giftDetail === undefined) {
      return null;
    }
    const modalButton = (
      <div
        className="statusDeliver"
        onClick={() => this.props.selectedProductForPreview(giftDetail, giftSection)}
      >
       {commonUtil.getLabel(labels.EventAdminPage, giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
      </div>
    );
    const giftPrice = commonUtil.getCurrency(giftDetail.price , true);
        const [giftPriceWhole, giftPricecents] = giftPrice?.split('.') ?? ['', ''];
      const giftPriceFormatted = (
        <>
        <span className="amount">{giftPriceWhole}</span><sup className="decimal">{giftPricecents}</sup>
        </>
      );
    
    const enableAddAgain =
      (this.props.compareEventStatus(
        this.props.eventStatus,
        defaultConst.eventStatus.ACTIVE,
      ) ||
        this.props.compareEventStatus(
          this.props.eventStatus,
          defaultConst.eventStatus.ADMINISTRATIVE_PROCESS,
        ) ||
        this.props.compareEventStatus(
          this.props.eventStatus,
          defaultConst.eventStatus.UNDER_REVIEW,
        )) &&
      (giftDetail.categoryName !== 'Gift Certificate' &&
        giftDetail.categoryName !== 'Certificado Electrónico');

    return (
      <React.Fragment>
        <div className="gift-card gift-card-received">
          <div className="row">
            <div className="col-md-6 col-sm-6">
               {/* <!-- Left: Image --> */}
                <div className="giftList-image">
                   <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
                </div>
                 {/* <!-- Center: Product details --> */}
            <div className="giftList-productDetails">
              <div className="product-title">{giftDetail.displayName}</div>
              <div className="product-meta">
                <p><strong>{commonUtil.getLabel(labels.EventAdminPage,"adminpage.comparas.sku.by.label")}:</strong> <span className="text-muted">{giftDetail.skuId}</span></p>
                <p><strong>{commonUtil.getLabel(labels.EventAdminPage, 'adminpage.regalosrecibidos.qty.label')}:</strong> <span className="text-muted">{giftDetail.quantity}</span></p>
              </div>
              {
                  this.props.compareEventStatus(giftDetail.deliveryStatus,"physical.delivery.message") ? (
                    modalButton
                  ) : ''
                }
            </div>
            </div>
            {/* <!-- Right: Price + Metadata --> */}
            <div className="col-md-6 col-sm-12 pl-0">
              <div className="row">
                <div className="col-sm-3">
                  <div className="price-display">
                    {giftPriceFormatted}
                  </div>
                </div>
                <div className="col-sm-9 pl-0 details-section">
                  {giftDetail && giftDetail.purchaseInfo ? (
                    <React.Fragment>
                      <div><strong>{commonUtil.getLabel(labels.EventAdminPage,"adminpage.comparas.date.label" )}:{" "}</strong> <span>{giftDetail.purchaseInfo.dateofPurchase}</span></div>
                     {
                      !giftDetail.isClickAndCollect && giftDetail.modeofDelivery === "physical" && !(giftDetail.deliveryStatus === "store.delivery.message" || giftDetail.deliveryStatus === 'return.delivery.message' || giftDetail.deliveryStatus === 'cancel.delivery.message' || giftDetail.deliveryStatus === 'return.reinvested.delivery.message') ? (
                        <div><strong>{commonUtil.getLabel(labels.EventAdminPage,"adminpage.comparas.delivery.address.label")}:{" "}</strong> <span>{giftDetail?.purchaseInfo?.deliveryAddress ?? ''} </span></div>
                      ) : (giftDetail.deliveryStatus == "store.delivery.message") ? (
                        <div><strong>{commonUtil.getLabel(labels.EventAdminPage,"adminpage.regalosrecibidos.warehouse.label")}:{" "}</strong> <span>{giftDetail?.purchaseInfo?.warehouseInfo ?? ''} </span></div>
                      ) : null
                     }

                     {
                      giftDetail.isClickAndCollect && 
                        <div>
                          <strong>
                            {commonUtil.getLabel(labels.EventAdminPage,"adminpage.comparas.delivery.address.label")}:{" "}
                          </strong>
                          <span>{giftDetail?.purchaseInfo?.deliveryAddress ?? ''} </span>
                        </div>
                     }
                      
                    </React.Fragment>
                  ) : null}
                   
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" onClick={() =>
                    this.props.selectedProductForPreview(giftDetail, giftSection)
                  }
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      right: '0px',
                      top: '50%',
                    }}>
                    <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                  </svg>
                   
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Status Tags --> */}
          <div className="row status-tags">
            <div className="col-md-6 col-sm-6 pl-0 pr-0">
              <div className="giftList-image">&nbsp;</div>
              <div className="giftList-productDetails">
              <>
                {
                  (
                    <React.Fragment>
                      {this.props.compareEventStatus(giftDetail.deliveryStatus, "store.delivery.message") ? (
                        <span className="tag statusDeliverToStore pull-right">
                          {/* Entregado en tienda */}
                          <span className="icon-circle"></span>
                          {commonUtil.getLabel(labels.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </span>
                      ) :
                        this.props.compareEventStatus(giftDetail.deliveryStatus, "electronic.delivery.message") || this.props.compareEventStatus(giftDetail.deliveryStatus, "physical.delivery.message") ? (
                          <span className="tag statusDeliverToStore"></span>
                        ) :this.props.compareEventStatus(giftDetail.deliveryStatus, "electronic.conversion.message") ? (
                        <span className="tag tag-electronic pull-right">
                          <span className="icon-circle"></span>
                          {commonUtil.getLabel(labels.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                        </span>
                      ): giftDetail.deliveryStatus ? (
                          <span className={`tag pull-right ${giftDetail.actionType === "returnReinvested" ? "tag-reinvested" : "tag-return"}`}>
                            <span className="icon-circle"></span>
                            {commonUtil.getLabel(labels.EventAdminPage,giftDetail.deliveryStatus) || giftDetail.deliveryStatus}
                          </span>
                        ): null}
                    </React.Fragment>
                  )
                  // modalButton
                }
              </>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 pl-0">
              <span className={`tag tag-bono ${eventContractInfo && eventContractInfo.bonus > 0 ? "" : "tag-bono-hidden"}`}>{commonUtil.getLabel(labels.EventAdminPage, "adminpage.regalosrecibidos.bonus.label")}
                {giftDetail.bonusInfo === "true" && this.props.eventType !== defaultConst.eventType.Others ? (
                  <span class="icon-done"></span>
                ) : (
                  <span className="x">x</span>
                )}
              </span>
              {
                (giftDetail.actionType === 'cancel' || giftDetail.actionType === 'return' || giftDetail.actionType === 'returnReinvested')  && (
<>
                {enableAddAgain ? (
                  <button className="btn-outline-pink pull-right" onClick={() => this.props.addAgain(giftDetail.skuId)}>
                    {commonUtil.getLabel(labels.EventAdminPage, "adminpage.regalosrecibidos.addagain.label")}
                  </button>
                ) : (
                  <button className="btn-outline-pink pull-right" disabled>
                    {commonUtil.getLabel(labels.EventAdminPage, "adminpage.regalosrecibidos.addagain.label")}
                  </button>
                )}
              </>
                )
              }
            </div>
          </div>
        </div>

      </React.Fragment>
    );
  }
}
export default Template;
